import { Component, EventEmitter, OnInit } from '@angular/core';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-faceid-login',
  templateUrl: './faceid-login.component.html',
  styleUrls: ['./faceid-login.component.scss']
})
export class FaceidLoginComponent implements OnInit {

  constructor(private services:ServiceStock) { }

  isAuthSuccess:boolean = false;
  ngOnInit() {
  }

  ngAfterViewInit(){
    var _this = this;
    setTimeout(function(){
      //_this.isAuthSuccess = true;
      _this.services.mobile.deviceAuth = new EventEmitter();
      _this.services.mobile.deviceAuth.subscribe(
        (res) => {
          if(res){
            _this.isAuthSuccess = true;
            setTimeout(function(){
              _this.services.onLoginSuccess();
              //_this.services.router.navigate(['/welcome/', 'welcomeuser']);
            }, 1500);
          }else{
            _this.services.router.navigate(['/welcome/', 'mpinlogin']);
          }
        }
      );
      _this.services.mobile.showTouchIDAuth();
    },1000);
  }

}
